<template>
  <div class="collapse-wapper">
    <section class="show-content">
      <slot />
    </section>
    <section class="hide-content" :style="{ height: toggleHeight }">
      <div class="hide-wrapper">
        <slot name="hide" />
      </div>
    </section>
    <p class="tip" @click="toggle">{{ collapseTip }}<i class="el-icon-arrow-down" :class="show ? 'transfrom' : ''" /></p>
  </div>
</template>

<script>
export default {
  name: 'CustomCollapse',
  props: {
    height: {
      type: Number,
      default: 250
    },
    collapseText: {
      type: Array,
      default: () => ['展开更多', '收起全部']
    }
  },
  data() {
    return {
      show: false,
      defaultHeight: '0px',
      hideHeight: 'auto'
    }
  },
  computed: {
    /**
     * @returns {String}
     */
    collapseTip() {
      const [closeText, openText] = this.collapseText
      return this.show ? openText : closeText
    },
    /**
     * @returns {String}
     */
    toggleHeight() {
      return this.show ? this.hideHeight : this.defaultHeight
    },
  },
  updated() {
    this.calHeight()
  },
  methods: {
    calHeight() {
      const wrapper = this.$el.querySelector('.hide-content .hide-wrapper')
      if (wrapper) {
        this.hideHeight = wrapper.clientHeight + 'px'
      }
    },
    open() {
      this.show = true
    },
    toggle() {
      this.show = !this.show
    }
  }
}
</script>
<style lang="scss" scoped>
.collapse-wapper {
  overflow: hidden;
}
.hide-content {
  overflow: hidden;
  transition: all .2s linear;
}
.tip {
  margin-top: 1px;
  float: right;
  color: #4071ff;
  cursor: pointer;

  .transfrom {
    transform: rotate(180deg);
  }
}
</style>
